import React from 'react';
import { Link } from 'react-router-dom';
import { useContact } from '../../App';

const Footer = () => {
  const contact = useContact();

  return (
    <footer className="bg-slate-900 text-slate-300">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 py-12">
        <div className="flex flex-col sm:flex-row justify-between items-center gap-6">
          <div className="text-center sm:text-right">
            <Link to="/" className="text-white font-semibold text-lg">
              استودیو آلتو
            </Link>
            <p className="text-slate-400 text-sm mt-1 max-w-xs">
              طراحی و توسعه وب — اصفهان
            </p>
          </div>
          <div className="flex flex-wrap justify-center gap-6 text-sm">
            <a href={`tel:${contact.tel}`} className="hover:text-white transition-colors">
              {contact.tel}
            </a>
            <a href={`mailto:${contact.email}`} className="hover:text-white transition-colors">
              {contact.email}
            </a>
            <a
              href={contact.whatsapp}
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-white transition-colors"
            >
              واتساپ
            </a>
          </div>
        </div>
        <div className="mt-8 pt-8 border-t border-slate-700 text-center text-slate-500 text-sm">
          © {new Date().getFullYear()} استودیو توسعه آلتو
        </div>
      </div>
    </footer>
  );
};

export default Footer;
